import { Box, styled } from "@mui/material";

export const ChatWindowWrapper = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  height: "100%",
});
